// store/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../actions/configApi';

export const checkAuth = createAsyncThunk("user/checkAuth", async () => {
  try {
    const response = await api.get("user"); // Endpoint que retorna os dados do usuário autenticado
    return response.data;
  } catch (error) {
    return null; // Retorna null se o usuário não estiver autenticado
  }
});

// Action para logout, chamando o endpoint correspondente
export const logout = createAsyncThunk("user/logout", async (_, { rejectWithValue }) => {
  try {
    await api.post("logout"); // Endpoint que realiza o logout
    return null;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  user: null,
  loading: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuth.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(checkAuth.rejected, (state) => {
        state.user = null;
        state.loading = false;
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.loading = false;
      })
      .addCase(logout.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
